import React from 'react';
import {BrowserRouter ,Route,Switch}from 'react-router-dom';
import './App.css';
import Login from './components/login/Login';
import ImportTabs from './components/importFiles/ImportTabs';

function App() {
  return (
    <div >
      <BrowserRouter basename={'/Ngp_Imports'}>
       <Switch >
         <Route exact path={'/'} component={Login} ></Route>
         <Route path={'/imports'} component={ImportTabs} ></Route>
       </Switch>
       </BrowserRouter>
    </div>
  );
}

export default App;
